import React from 'react';

export const IconUser =() => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M13,3A10,10,0,1,0,23,13,10,10,0,0,0,13,3Zm0,3a3,3,0,1,1-3,3A3,3,0,0,1,13,6Zm0,14.2a7.2,7.2,0,0,1-6-3.22c.03-1.99,4-3.08,6-3.08s5.97,1.09,6,3.08A7.2,7.2,0,0,1,13,20.2Z" transform="translate(-3 -3)" fill="#9ca3af"/></svg>;
}